import { RootState } from '../../reducers';

export const selectLastLoadedDate = (state: RootState) =>
  state.addContentPage.lastLoadedDate;

export const selectSearchQuery = (state: RootState) =>
  state.addContentPage.searchQuery;

export const selectSortOptions = (state: RootState) =>
  state.addContentPage.sortOptions;

export const selectLayoutOptions = (state: RootState) =>
  state.addContentPage.layoutOptions;

export const selectIsLoadingLibrary = (state: RootState) =>
  state.addContentPage.isLoading;

export const selectSelectedItems = (state: RootState) =>
  state.addContentPage.selectedItems;

export const selectItemsToAdd = (state: RootState) =>
  state.addContentPage.itemsToAdd;

export const selectAddToPlaylistIdBySelectionId = (state: RootState) =>
  state.addContentPage.addToPlaylistIdBySelectionId;
